/* Cover My Plate theme additions: cart bridge, personalization, package picker, cart upsell, customizer bridges. */
(function () {
  'use strict';

  const CMP = (window.CMP = window.CMP || {});
  const SECTIONS = ['cart-drawer', 'cart-icon-bubble'];

  /* ---------- Money ---------- */
  CMP.formatMoney = function (cents) {
    const format = CMP.moneyFormat || '${{amount}}';
    const value = (Number(cents) || 0) / 100;
    const withCommas = (n, dec, thou, decSep) => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return dec ? parts.join(decSep) : parts[0];
    };
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      switch (key) {
        case 'amount_no_decimals':
          return withCommas(value, 0, ',', '.');
        case 'amount_with_comma_separator':
          return withCommas(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator':
          return withCommas(value, 0, '.', ',');
        default:
          return withCommas(value, 2, ',', '.');
      }
    });
  };

  /* ---------- Cart refresh (used by packages, upsells, configurators, apps) ---------- */
  CMP.refreshCart = function (openDrawer) {
    // No cart drawer on this theme: go straight to the cart page instead of first fetching sections we'd throw
    // away (that fetch added ~1.5 s to Add to cart on the Japanese builder). Nov 2026.
    if (openDrawer && !document.querySelector('cart-drawer')) {
      window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      return Promise.resolve();
    }
    const url = window.location.pathname + '?sections=' + SECTIONS.join(',');
    return fetch(url, { headers: { 'X-CMP': '1' } })
      .then((r) => r.json())
      .then((sections) => {
        const drawer = document.querySelector('cart-drawer');
        if (drawer && typeof drawer.renderContents === 'function') {
          if (openDrawer) {
            drawer.renderContents({ sections: sections });
          } else {
            SECTIONS.forEach((id) => {
              const target = id === 'cart-drawer' ? document.querySelector('#CartDrawer') : document.getElementById(id);
              if (!target || !sections[id]) return;
              const html = new DOMParser().parseFromString(sections[id], 'text/html');
              const src = id === 'cart-drawer' ? html.querySelector('#CartDrawer') : html.querySelector('.shopify-section');
              if (src) target.innerHTML = src.innerHTML;
            });
          }
        } else if (openDrawer) {
          window.location.href = (window.routes && window.routes.cart_url) || '/cart';
          return;
        }
        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'cmp' });
        }
      })
      .catch(() => {
        if (openDrawer) window.location.href = '/cart';
      });
  };

  CMP.addItems = function (items) {
    return fetch(((window.routes && window.routes.cart_add_url) || '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-CMP': '1' },
      body: JSON.stringify({ items: items }),
    }).then((r) =>
      r.json().then((json) => {
        if (!r.ok || json.status) throw json;
        return json;
      })
    );
  };

  /* Any other script that adds to cart with fetch (plate configurator, Japanese customizer, apps)
     gets the drawer refreshed and opened, like the old theme's ajaxProduct:added hook. */
  const originalFetch = window.fetch;
  window.fetch = function (resource, config) {
    const url = typeof resource === 'string' ? resource : resource && resource.url;
    const isAdd = url && url.indexOf('/cart/add') !== -1 && (config && String(config.method).toUpperCase() === 'POST');
    const headers = (config && config.headers) || {};
    const ours = headers['X-CMP'] || (headers.get && headers.get('X-CMP'));
    const fromDawn = config && config.body instanceof FormData && config.body.has('sections');
    const p = originalFetch.apply(this, arguments);
    const isGuard = headers['X-CMP-Guard'] || (headers.get && headers.get('X-CMP-Guard'));
    const isChange = url && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url) && config && String(config.method).toUpperCase() === 'POST';
    if (isChange && !isGuard) p.then((res) => { if (res.ok && CMP.guardQR) queueGuard(); }).catch(() => {});
    if (isAdd && !ours && !fromDawn) {
      p.then((res) => {
        if (res.ok) CMP.refreshCart(true);
      }).catch(() => {});
    }
    return p;
  };

  /* ---------- QR code add-on guard ----------
     A social cover with a QR code ("QR Code" is a link) needs one "QR Code Add-on" line per cover, matched by
     "For: @handle social cover". After any cart change this puts the add-on back if it went missing, matches its
     quantity to the cover, and removes add-ons whose cover is gone. The cart page and drawer also hide its buttons. */
  const QR_HANDLE = 'qr-code-add-on';
  let qrBusy = false, qrAgain = false, qrVariant = null;
  const isCover = (it) => it.properties && it.properties['Vehicle Type'] && /^https?:\/\//i.test(String(it.properties['QR Code'] || '')) && !/qr/i.test(it.variant_title || ''); // a "with QR" variant already includes it
  const qrFor = (it) => '@' + it.properties.USERNAME + ' social cover';
  function guardPost(path, body) {
    return originalFetch(((window.Shopify && Shopify.routes && Shopify.routes.root) || '/') + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-CMP': '1', 'X-CMP-Guard': '1' },
      body: JSON.stringify(body),
    }).then((r) => r.json());
  }
  function qrVariantId(cart) {
    const line = cart.items.find((it) => it.handle === QR_HANDLE);
    if (line) return Promise.resolve(line.variant_id);
    if (qrVariant) return Promise.resolve(qrVariant);
    return originalFetch('/products/' + QR_HANDLE + '.js').then((r) => r.json()).then((p) => {
      const v = (p.variants || []).find((x) => x.available) || (p.variants || [])[0];
      return (qrVariant = v ? v.id : null);
    }).catch(() => null);
  }
  CMP.guardQR = function () {
    if (qrBusy) { qrAgain = true; return Promise.resolve(false); }
    qrBusy = true;
    return originalFetch('/cart.js', { headers: { Accept: 'application/json' } }).then((r) => r.json()).then((cart) => {
      const need = {}, set = {}, have = {};
      cart.items.forEach((it) => { if (isCover(it)) { const k = qrFor(it); need[k] = (need[k] || 0) + it.quantity; set[k] = set[k] || it.properties._Set || ''; } });
      cart.items.forEach((it) => { if (it.handle === QR_HANDLE) { const k = (it.properties && it.properties.For) || ''; (have[k] = have[k] || []).push(it); } });
      const updates = {}, adds = [];
      Object.keys(have).forEach((k) => {
        let left = need[k] || 0;
        have[k].forEach((it) => { const q = Math.min(it.quantity, left); left -= q; if (q !== it.quantity) updates[it.key] = q; });
        if (left > 0) { const f = have[k][0]; updates[f.key] = (updates[f.key] !== undefined ? updates[f.key] : f.quantity) + left; }
      });
      Object.keys(need).forEach((k) => { if (!have[k]) adds.push(k); });
      if (!Object.keys(updates).length && !adds.length) return false;
      let job = Promise.resolve();
      if (Object.keys(updates).length) job = job.then(() => guardPost('cart/update.js', { updates: updates }));
      if (adds.length) job = job.then(() => qrVariantId(cart)).then((id) => {
        if (!id) return;
        return guardPost('cart/add.js', { items: adds.map((k) => { const pr = { For: k }; if (set[k]) pr._Set = set[k]; return { id: id, quantity: need[k], properties: pr }; }) });
      });
      return job.then(() => true);
    }).catch(() => false).then((changed) => {
      qrBusy = false;
      if (qrAgain) { qrAgain = false; return CMP.guardQR(); }
      if (changed) {
        CMP.refreshCart(false);
        document.dispatchEvent(new CustomEvent('cmp:cart-fixed'));
      }
      return changed;
    });
  };
  let qrTimer = null;
  const queueGuard = () => { clearTimeout(qrTimer); qrTimer = setTimeout(CMP.guardQR, 250); };
  document.addEventListener('DOMContentLoaded', () => { if (/\/cart\/?$/.test(location.pathname) || document.querySelector('cart-drawer')) queueGuard(); });
  document.addEventListener('ajaxProduct:added', () => CMP.refreshCart(true));

  /* Old customizer scripts listen for Impulse's "variant:change" DOM event. */
  document.addEventListener('DOMContentLoaded', () => {
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
        const variant = event && event.data && event.data.variant;
        if (!variant) return;
        document.dispatchEvent(new CustomEvent('variant:change', { detail: { variant: variant } }));
        document.querySelectorAll('cmp-packages').forEach((el) => el.setBaseVariant(variant));
      });
    }
  });

  /* ---------- Personalization block ---------- */
  class CmpPersonalize extends HTMLElement {
    connectedCallback() {
      this.handleInput = this.querySelector('[data-cmp-handle]');
      this.counter = this.querySelector('[data-cmp-count]');
      this.previewHandle = this.querySelectorAll('[data-cmp-preview-handle]');
      this.previewPlatform = this.querySelectorAll('[data-cmp-preview-platform]');
      this.placeholder = this.dataset.placeholder || '@yourhandle';
      this.addPrefix = this.dataset.prefix === 'true';
      this.addEventListener('input', () => this.update());
      this.addEventListener('change', () => this.update());
      this.update();
    }
    value() {
      let v = (this.handleInput && this.handleInput.value.trim()) || '';
      if (v && this.addPrefix && v.charAt(0) !== '@') v = '@' + v;
      return v;
    }
    platform() {
      const checked = this.querySelector('input[type="radio"]:checked');
      return checked ? checked.value : '';
    }
    update() {
      const v = this.value();
      if (this.counter && this.handleInput) this.counter.textContent = this.handleInput.value.length;
      this.previewHandle.forEach((el) => (el.textContent = v || this.placeholder));
      const p = this.platform();
      this.previewPlatform.forEach((el) => (el.textContent = p ? 'Follow on ' + p : ''));
      this.classList.toggle('cmp-personalize--error', false);
    }
    validate() {
      if (!this.handleInput || !this.handleInput.required) return true;
      const ok = this.handleInput.value.trim().length > 0;
      this.classList.toggle('cmp-personalize--error', !ok);
      if (!ok) {
        this.handleInput.focus();
        this.scrollIntoView({ behavior: 'smooth', block: 'center' });
      }
      return ok;
    }
    properties() {
      const props = {};
      this.querySelectorAll('[name^="properties["]').forEach((el) => {
        if ((el.type === 'radio' || el.type === 'checkbox') && !el.checked) return;
        const key = el.name.slice(11, -1);
        let val = el.value;
        if (el === this.handleInput) val = this.value();
        if (val) props[key] = val;
      });
      return props;
    }
  }
  if (!customElements.get('cmp-personalize')) customElements.define('cmp-personalize', CmpPersonalize);

  /* ---------- Package picker ---------- */
  class CmpPackages extends HTMLElement {
    connectedCallback() {
      this.formId = this.dataset.formId;
      this.basePrice = Number(this.dataset.basePrice) || 0;
      this.options = Array.from(this.querySelectorAll('[data-cmp-package]'));
      this.addEventListener('change', () => this.update());
      this.update();
      this.hookSubmit();
    }
    setBaseVariant(variant) {
      if (!variant || typeof variant.price === 'undefined') return;
      this.basePrice = Number(variant.price);
      this.update();
    }
    selected() {
      return this.options.find((o) => o.querySelector('input[type="radio"]').checked) || this.options[0];
    }
    extrasFor(option) {
      return Array.from(option.querySelectorAll('[data-cmp-extra]')).map((extra) => {
        const select = extra.querySelector('select');
        const chosen = select ? select.options[select.selectedIndex] : null;
        return {
          id: Number(chosen ? chosen.value : extra.dataset.variantId),
          price: Number(chosen ? chosen.dataset.price : extra.dataset.price) || 0,
          title: extra.dataset.title,
        };
      });
    }
    totals(option) {
      const extras = this.extrasFor(option);
      const full = this.basePrice + extras.reduce((a, e) => a + e.price, 0);
      const type = option.dataset.discountType;
      const val = Number(option.dataset.discountValue) || 0;
      let off = 0;
      if (type === 'amount') off = Math.round(val * 100);
      if (type === 'percent') off = Math.round((full * val) / 100);
      off = Math.min(off, full);
      return { full: full, price: full - off, off: off, extras: extras };
    }
    update() {
      this.options.forEach((o) => {
        const t = this.totals(o);
        o.classList.toggle('is-selected', o === this.selected());
        const price = o.querySelector('[data-cmp-price]');
        const was = o.querySelector('[data-cmp-was]');
        const save = o.querySelector('[data-cmp-save]');
        if (price) price.textContent = CMP.formatMoney(t.price);
        if (was) {
          was.textContent = t.off ? CMP.formatMoney(t.full) : '';
          was.hidden = !t.off;
        }
        if (save) {
          save.textContent = t.off ? (this.dataset.saveLabel || 'You save') + ' ' + CMP.formatMoney(t.off) : '';
          save.hidden = !t.off;
        }
      });
      const t = this.totals(this.selected());
      this.updateButton(t);
    }
    updateButton(t) {
      const form = document.getElementById(this.formId);
      const btn = form && form.querySelector('[type="submit"]');
      if (!btn || btn.disabled) return;
      const span = btn.querySelector('span');
      if (!span) return;
      if (!span.dataset.cmpDefault) span.dataset.cmpDefault = span.textContent.trim();
      const isPackage = t.extras.length > 0;
      span.textContent = (isPackage ? this.dataset.packageLabel || 'Add package' : span.dataset.cmpDefault) + ' · ' + CMP.formatMoney(t.price);
    }
    hookSubmit() {
      const form = document.getElementById(this.formId);
      const wrapper = form && form.closest('product-form');
      if (!wrapper || wrapper.dataset.cmpHooked) return;
      wrapper.dataset.cmpHooked = 'true';
      wrapper.addEventListener('submit', (evt) => this.onSubmit(evt, form, wrapper), true);
    }
    onSubmit(evt, form, wrapper) {
      const personalizers = Array.from(document.querySelectorAll('cmp-personalize[data-form-id="' + this.formId + '"]'));
      if (!personalizers.every((p) => p.validate())) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
        return;
      }
      const option = this.selected();
      const t = this.totals(option);
      if (!t.extras.length) return; /* single item: Dawn's own form submit handles it */

      evt.preventDefault();
      evt.stopImmediatePropagation();
      const btn = form.querySelector('[type="submit"]');
      btn && btn.classList.add('loading');
      btn && btn.setAttribute('aria-disabled', 'true');
      wrapper.querySelector('.loading__spinner') && wrapper.querySelector('.loading__spinner').classList.remove('hidden');

      const fd = new FormData(form);
      const props = {};
      for (const [k, v] of fd.entries()) {
        if (k.indexOf('properties[') === 0 && v) props[k.slice(11, -1)] = v;
      }
      personalizers.forEach((p) => Object.assign(props, p.properties()));
      const packageName = option.dataset.title;
      const mainProps = Object.assign({}, props, { Package: packageName });
      const extraProps = this.dataset.copyProps === 'true' ? Object.assign({}, props) : {};
      const items = [{ id: Number(fd.get('id')), quantity: Number(fd.get('quantity')) || 1, properties: mainProps }];
      t.extras.forEach((e) => {
        items.push({
          id: e.id,
          quantity: Number(fd.get('quantity')) || 1,
          properties: Object.assign({}, extraProps, { Package: packageName, 'For item': this.dataset.productTitle }),
        });
      });

      const errorWrap = wrapper.querySelector('.product-form__error-message-wrapper');
      CMP.addItems(items)
        .then(() => {
          if (errorWrap) errorWrap.hidden = true;
          return CMP.refreshCart(true);
        })
        .catch((err) => {
          if (errorWrap) {
            errorWrap.hidden = false;
            const msg = errorWrap.querySelector('.product-form__error-message');
            if (msg) msg.textContent = (err && (err.description || err.message)) || 'Could not add this package.';
          }
        })
        .finally(() => {
          btn && btn.classList.remove('loading');
          btn && btn.removeAttribute('aria-disabled');
          wrapper.querySelector('.loading__spinner') && wrapper.querySelector('.loading__spinner').classList.add('hidden');
        });
    }
  }
  if (!customElements.get('cmp-packages')) customElements.define('cmp-packages', CmpPackages);

  /* Personalization without a package block still needs its required check. */
  document.addEventListener(
    'submit',
    (evt) => {
      const form = evt.target;
      if (!form || !form.id) return;
      if (document.querySelector('cmp-packages[data-form-id="' + form.id + '"]')) return;
      const personalizers = Array.from(document.querySelectorAll('cmp-personalize[data-form-id="' + form.id + '"]'));
      if (personalizers.length && !personalizers.every((p) => p.validate())) {
        evt.preventDefault();
        evt.stopImmediatePropagation();
      }
    },
    true
  );

  /* ---------- Cart upsell quick add ---------- */
  document.addEventListener('click', (evt) => {
    const btn = evt.target.closest('[data-cmp-quick-add]');
    if (!btn) return;
    evt.preventDefault();
    btn.classList.add('loading');
    btn.setAttribute('aria-disabled', 'true');
    CMP.addItems([{ id: Number(btn.dataset.variantId), quantity: 1 }])
      .then(() => CMP.refreshCart(true))
      .catch(() => {
        btn.classList.remove('loading');
        btn.removeAttribute('aria-disabled');
      });
  });
})();
